// @ts-nocheck
import FormResultsContext from './context';
import useStatesandActions from './useStateandActions';
const FormResultsProvider = ({ children }) => (
  <FormResultsContext.Provider value={useStatesandActions()}>
    {children}
  </FormResultsContext.Provider>
);

export default FormResultsProvider;
